module.exports = __webpack_public_path__ + "img/cate_product3.9ed1c9b4.png";